// extracted by mini-css-extract-plugin
module.exports = {"search__input":"ob_qA0tkr","search__inputSelected":"ob_U9aXgF","search__inputSelected_label":"ob_tg317M","search__searchIcon":"ob_SUKvtZ"};